import { render } from "./LoopsResultsLinks.vue?vue&type=template&id=8165f832"
import script from "./LoopsResultsLinks.vue?vue&type=script&lang=js"
export * from "./LoopsResultsLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__